import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { ReportFilters } from 'src/shared/models/report-filters.model';
import { Subject } from 'rxjs';
import { Constants } from 'src/shared/utilities/constants.util';
import { ReportService } from 'src/shared/services/report.service';

@Component({
  selector: 'smt-nurse-summary',
  templateUrl: './nurse-summary.component.html',
  styleUrls: ['./nurse-summary.component.scss']
})
export class NurseSummaryComponent implements OnInit {

  filters:ReportFilters;
  defaultFilters:ReportFilters;
  eventsSubject: Subject<void> = new Subject<void>();
  reportType = ["inpatient"];

  constructor(private reportService: ReportService){
  }

  ngOnInit() {
    this.filters = new ReportFilters();
    this.filters.ReportView = 'Pay Period Ending';
    this.filters.isSummary = true;
    this.defaultFilters = new ReportFilters();
    this.reportService.announceSummarySelected(Constants.NurseSummary);
  } 

  filterUpdated(filters: ReportFilters) {
      this.filters = filters;
      /**
       * @TOOD - rework all the reports to receive the filters in the observable, so we don't need this hack
       */
      setTimeout(() => this.eventsSubject.next(), 1);
  }

}
